const ikson = {
    init() {
        //
    },
    subscribe(element) {
        $(element).html('<i class="far fa-spinner fa-spin"></i>');
        $(element).css('pointer-events', 'none');
        fetch('/my/newsletter', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': $('#g_csrf').val()
            }
        }).then(function (response) {
            if (response.ok) {
                return response.text();
            }
            alert('There was an error subscribing.');
            $(element).css('pointer-events', 'auto');
            $(element).html('Subscribe');
        }).then(function (html) {
            $(element).html(html);
        }).catch(function(error) {
            alert('There was an error subscribing.');
            $(element).css('pointer-events', 'auto');
            $(element).html('Subscribe');
        });
    },
    /*memberUploadPhoto() {
        const r_file = $('#imageUpload');
        let formdata = new FormData();
        let file = r_file[0].files[0];

        if (file !== undefined) {
            formdata.append('file1', file);
        } else {
            // User didn't select a file
            return false;
        }

        $('#imgUploadButton').html('<i class="far fa-spinner fa-spin"></i>');

        fetch('/my/photo', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': $('#g_csrf').val()
            },
            body: formdata
        })
        .then(response => response.json())
        .then(function (resp) {
            $('#imgUploadButton').html('Upload');

            if (resp.url === undefined) {
                alert('There was an error uploading your photo. Please refresh the page and try again.');
            } else {
                $('#imagePreview').css('background-image', 'url("' + resp.url + '")');
                $('#imgUploadedName').val(resp.name);
            }
        }).catch(function(error) {
            $('#imgUploadButton').html('Upload');
            alert('There was an error uploading your photo. Please refresh the page and try again.');
        });
    },*/
    /*addSocial(check_limit) {
        if (check_limit) {
            let platform_count = $('#platform_count').val();
            let platforms = 0;
            $('#bottom-anchor select').each(function(index) {
                platforms++;
            });
            if (platforms >= platform_count) {
                alert('You have reached the limits of the Personal Subscription. Upgrade to Commercial Subscription to add more accounts (including multiple accounts on the same network).');
                return false;
            }
        }

        let html = $('#gold-template').html();
        let counter = parseInt($('#social_count').val());
        counter++;
        $('#social_count').val(counter);

        html = html.replace('social-zone-0', 'social-zone-' + counter);
        html = html.replace('platform[0]', 'platform[' + counter + ']');
        html = html.replace('social[0]', 'social[' + counter + ']');
        html = html.replace('deleteSocial(0)', 'deleteSocial(' + counter + ')');
        $('#bottom-anchor').append(html);
        $('select').chosen('destroy');
        $('select').not('.no-style').chosen();
        ikson.pCountProcess();
    },*/
    deleteSocial(sid) {
        if (confirm('Are you sure you want to delete this link?')) {
            $('#social-zone-' + sid).remove();
            ikson.pCountProcess();
        }
    },
    /*selectChangeSocial(that) {
        ikson.pCountProcess(that);
    },*/
    enable2FA(that) {
        $(that).html('<i class="far fa-spinner fa-spin"></i>');
        fetch('/me/generate-2fa', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': $('#g_csrf').val()
            }
        }).then(response => response.json())
        .then(function (resp) {
            let json = resp;
            $(that).hide();
            $('#tfa-cd').val(json.key);
            $('.qr').html(json.qr);
            $('.tfa-zones').show();
        }).catch(function(error) {
            alert('There was an error generating your code.');
        });
    },
    disable2FA(that) {
        if (confirm('Are you sure you want to disable 2FA?')) {
            $(that).html('<i class="far fa-spinner fa-spin"></i>');
            fetch('/me/disable-2fa', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': $('#g_csrf').val()
                }
            }).then(response => response.json())
                .then(function (resp) {
                    window.location.reload();
                }).catch(function (error) {
                alert('There was an error disabling 2FA.');
            });
        }
    },
    cancelSubscription(that, uuid) {
        $(that).html('<i class="far fa-spinner fa-spin"></i>');
        $(that).css('pointer-events', 'none');
        let formdata = new FormData();
        formdata.append('uuid', uuid);

        fetch('/my/subscriptions/cancel', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': $('#g_csrf').val()
            },
            body: formdata
        }).then(response => response.json())
        .then(function (resp) {
            if (resp.status === 'OK') {
                location.href = '/my/subscriptions';
            } else {
                $(that).html('Error cancelling');
                alert(resp.message);
            }
        }).catch(function(error) {
            $(that).html('Error cancelling');
            alert('There was an error cancelling your subscription. Please contact us.');
        });
    },
    loadDownload(track_id) {
        $('#download-info-zone').html('<div class="text-center"><h3><i class="fa-solid fa-spinner fa-spin"></i></h3></div>');
        fetch('/track/download-info/' + track_id, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': $('#g_csrf').val()
            }
        }).then(response => response.text())
        .then(function (html) {
            $('#download-info-zone').html(html);
        }).catch(function(error) {
            alert('There was an error obtaining the download details.');
        });
    },
    logPlay(track_id) {
        fetch('/track/log-play/' + track_id, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': $('#g_csrf').val()
            }
        }).then(response => response.text())
        .then(function (html) {
        }).catch(function(error) {
        });
    },
    ctc(that) {
        let data = $(that).attr('data-data');
        var $temp = $('<input>');
        $('body').append($temp);
        $temp.val(data).select();
        document.execCommand('copy');
        $temp.remove();
        $('body').append('<p class="copy-message">Attribution text copied!</p>');
        setTimeout(function () {
            $('.copy-message').fadeOut();
        }, 1500);
    },
    /*subLinksForm() {
        let platform_count = $('#platform_count').val();
        let platforms = 0;
        let proceed = true;
        let platform_ids = [];
        $('#bottom-anchor select').each(function(index) {
            platforms++;
            // One platform added more than once
            if (platform_ids.includes(parseInt($(this).val()))) {
                proceed = false;
            }
            platform_ids.push(parseInt($(this).val()));
            // More than the allowed number of unique plaforms
            if (platforms > platform_count) {
                proceed = false;
            }
        });
        if (!proceed) {
            alert('You have reached the limits of the Personal Subscription. Upgrade to Commercial Subscription to add more accounts (including multiple accounts on the same network).');
            return false;
        }
        return true;
    },*/
    enableSaveButton() {
        $('#profile-save-button').css('pointer-events', 'auto').css('color', '#FFFFFF');
    },
    /*pCountProcess(that = null) {
        if ($('#plan-type-c').length > 0 && parseInt($('#plan-type-c').val()) === 1) { // Commercial plan?
            let too_many = false;

            // 1. Generate the counts for the top icons based on all selections made
            $('.pcounts').attr('data-total', 0);

            $('select.no-style').each(function(index) {
                let val = $(this).val();
                if (val > 0) {
                    let existing_count = parseInt($('#pcount' + val).attr('data-total'));
                    existing_count++;
                    $('#pcount' + val).attr('data-total', existing_count);
                }
            });

            // 2. If a count is on 0, don't allow select of it in the dropdown
            $('.pcounts').each(function(index) {
                let left = 3 - parseInt($(this).attr('data-total'));
                if (left < 0) {
                    too_many = true;
                    left = 0;
                }
                $(this).html(left);
            });

            // 3. Final
            if (too_many) {
                alert('You are limited to 3 links per platform. Please change your selection, or contact us for additional support.');
                //$('.socialsubmit').hide();
                if (that !== null) {
                    $(that).val($(that).attr('data-prev'));
                }
            } else {
                //$('.socialsubmit').show();
            }
        }
    },*/
};
$(document).ready(ikson.init);

// Preserve the existing Blade inline-handler interface.
window.ikson = ikson;

export default ikson;
